import { render, staticRenderFns } from "./52200003.vue?vue&type=template&id=dff48e5e&scoped=true&"
import script from "./52200003.vue?vue&type=script&lang=js&"
export * from "./52200003.vue?vue&type=script&lang=js&"
import style0 from "./52200003.vue?vue&type=style&index=0&id=dff48e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff48e5e",
  null
  
)

export default component.exports